import React from 'react'

import './styles.scss'

const ButtonsList = ({ buttonsConfig }) => {
    return (
        <div className="holder-wrap">
            <div className="btn-holder">
                <ul className="btn-list">
                    {buttonsConfig.map(({ classes, text, status, callHandler }) => {
                        return (
                            <li key={text}>
                                <button disabled={status} className={classes} onClick={callHandler}>
                                    {text}
                                </button>
                            </li>
                        )
                    })}
                </ul>
            </div>
        </div>
    )
}

export default React.memo(ButtonsList)
